/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
window.PXUTheme.jsLogoList = {
  init: function($section) {

    //console.log("LOGO LIST:", $section[0].querySelector('.logo-list__wrapper'));

    window.PXUTheme.jsLogoList = $.extend(this, window.PXUTheme.getSectionData($section));

    //console.log("MOBILE SLIDER:",this.mobile_slider);

    if(this.mobile_slider){

      const carousel = $section[0].querySelector('.logo-list-slider');

      let flkty;

      function manageFlickity() {
        const breakpoint = 799; // Set the breakpoint width
        
        if (window.innerWidth < breakpoint) {
          if (!carousel.classList.contains('flickity-enabled')) {
            flkty = new Flickity(carousel, {
              watchCSS: false,
              cellAlign: 'left',
              contain: true,
              pageDots: false,
              wrapAround: true,
              prevNextButtons: false,
              autoPlay: true
            });
          }
        } else {
          if (carousel.classList.contains('flickity-enabled')) {
            if (flkty) {
              flkty.destroy();
              flkty = null;
            }
          }
        }
      }

      manageFlickity();

      window.addEventListener('resize', manageFlickity);

      function debounce(func, wait) {
        let timeout;
        return function () {
          clearTimeout(timeout);
          timeout = setTimeout(() => func.apply(this, arguments), wait);
        };
      }

      window.addEventListener('resize', debounce(manageFlickity, 250));
    }
  }
}

/******/ })()
;